import MassageModel from '../model/massage';
export const GET_MASSAGE = 'GET_MASSAGE';
export const SET_UNREAD = 'SET_UNREAD';

export const get_unread = () => {
  return async (dispatch, getState) => {
    const id = getState().authReduse.id;
    if (!id) return;
    const res = await fetch(`/api/cn/unread/${id}`);
    if (!res.ok) return;
    const data = await res.json();
    dispatch({ type: SET_UNREAD, total: Number(data.total || 0) });
  };
};

export const mark_chat_seen = (from_user, to_user) => {
  return async (dispatch) => {
    await fetch('/api/cn/seen', {
      method: 'POST',
      headers: { 'content-Type': 'application/json' },
      body: JSON.stringify({ from_user, to_user })
    });
    dispatch(get_unread());
  };
};

export const  get_massage = () =>{
  return async (dispatch,getState) =>{
      const id = getState().authReduse.id;
    const res= await fetch(`/api/cn/notifactions/${id}`);
    const data =[];
     const ress = await res.json();
    if (!Array.isArray(ress)) return;
    for(const key in ress){
    data.push(new MassageModel(
      ress[key].id,
      ress[key].to_user,
      ress[key].last_message || ress[key].content,
      ress[key].from_user,
      ress[key].last_created || ress[key].time,
      (ress[key].from_user === 'pinweelo' || ress[key].from_user === 'pinweelo-system')
        ? (ress[key].userImg || '/icon-192.png')
        : ress[key].userImg,
      ress[key].from_user === 'pinweelo' || ress[key].from_user === 'pinweelo-system' ? 'Pinweelo' : ress[key].userName,
      Number(ress[key].unread || 0),
      ress[key].userStory
    ))
    }

    dispatch({type:GET_MASSAGE,data:data})
    const total = data.reduce((sum, item) => sum + (item.unread || 0), 0);
    dispatch({ type: SET_UNREAD, total });
  }
}
